import appConfig from './config.js';
import roleHelper from './roleHelper.js';
import router from '@/router';

/**
 * 设置当前状态
 **/
const setState = function(state) {
    state = state || {};
    state.id = state._id; //兼容ID的写法
    window.localStorage.setItem(appConfig.stateKeyName, JSON.stringify(state));
};
/**
 * .userId
 * 获取当前状态
 **/
const getState = function() {
    // console.log("getState-appConfig.stateKeyName:" + appConfig.stateKeyName);
    let value = window.localStorage.getItem(appConfig.stateKeyName);
    // console.log("getState state:" + value);
    if (value == '' || !value) {
        value = '{}';
    }
    value = JSON.parse(value);
    return value;
};
/**
 * 设置当前状态
 **/
const clearState = function() {
    window.localStorage.removeItem(appConfig.stateKeyName);
};

const whetherLand = function() {
    var state = getState();
    if (state.id == undefined && state._id == undefined) {
        return false;
    }
    return true;
};

/**
 * 设置token到本地
 * @param {Object} token
 */
const setToken = function(token) {
    window.localStorage.setItem(appConfig.tokenKeyName, token);
};
/**
 * 从本地得到token对象
 */
const getToken = function() {
    const value = window.localStorage.getItem(appConfig.tokenKeyName);
    return value;
};
/**
 * 清除token对象
 */
const clearToken = function() {
    window.localStorage.removeItem(appConfig.tokenKeyName);
};

/**
 * 本地退出登录，不做任何网请求
 * @param {Object} context vue的this对象
 * @param {Object} isToLogin 是否跳转到登录页面
 */
const localLogout = function(context, isToLogout) {
    clearToken();
    clearState();
    isToLogout = isToLogout === undefined ? true : isToLogout;
    if (isToLogout) {
        toLogin(context);
    }
};

/**
 * 跳转到登录页面
 * 记得该方法一定要登录过才能使用
 * @param {Object} context
 */
const toLogin = function(context) {
    let path = getLoginPath();
    router.app.$router.push(path);
};

/**
 * 记得该方法一定要登录过才能使用
 */
const getLoginPath = function() {
    return '/login';
};

/**
 * 设置入口信息
 * @param {Object} token
 */
const setEntrance = function(entrance) {
    window.localStorage.setItem(appConfig.appAlias + '_entrance', entrance);
};
/**
 * 从本地得到入口信息
 */
const getEntrance = function() {
    let value = window.localStorage.getItem(appConfig.appAlias + '_entrance');
    value = value || roleHelper.defaultAlias;
    return value;
};

/**
 * 清除入口信息
 */
const clearEntrance = function() {
    window.localStorage.removeItem(appConfig.appAlias + '_entrance');
};

/**
 * 得到URL上的根目录（除工程名外第一层）
 */
const getUrlRootName = function(path) {
    if (!path) {
        return roleHelper.ROLE_CONFIG.defaultAlias;
    }
    let paths = path.split('/'); // /(\\w*)?
    if (paths.length < 2) {
        return roleHelper.ROLE_CONFIG.defaultAlias;
    }
    return paths[1];
};

/**
 * 返回： 协议://域名:端口/工程名
 * @param {Object} context
 */
const getUrlRoot = function(context) {
    let path = router.app.$route.path;
    let rootName = getUrlRootName(path);

    let url = document.location.href;
    var myURL = new URL(url);
    let origin = myURL.origin; //http://XXXX:端口。包括(协议://域名:端口)
    return origin + '/' + rootName;
};
/**
 * 返回： 协议://域名:端口
 * 注：此方法不带工程名
 * @param {Object} context
 */
const getUrlDomainName = function(context) {
    let url = document.location.href;
    var myURL = new URL(url);
    return myURL.origin;
};

/**
 * 设置数据对象到本地
 * @param {Object} token
 */
const setItem = function(key, value) {
    key = appConfig.stateKeyName + '-' + key;
    window.localStorage.setItem(key, JSON.stringify(value));
};
/**
 * 从本地得到数据对象
 */
const getItem = function(key) {
    key = appConfig.stateKeyName + '-' + key;
    let value = window.localStorage.getItem(key);
    if (value == '' || !value) {
        value = '{}';
    }
    value = JSON.parse(value);
    return value;
};
/**
 * 清除数据对象数据对象
 */
const clearItem = function(key) {
    key = appConfig.stateKeyName + '-' + key;
    window.localStorage.removeItem(key);
};

export default {
    setState,
    getState,
    clearState,
    whetherLand,

    setToken,
    getToken,
    clearToken,

    localLogout,
    toLogin,
    getLoginPath,

    setEntrance,
    getEntrance,
    clearEntrance,

    setItem,
    getItem,
    clearItem,

    getUrlRootName,
    getUrlRoot,
    getUrlDomainName
};
